module.exports = __webpack_public_path__ + "assets/img/962d42003c846266a3c4473baf656c77.png";